import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_camp: FaireCollectionEntity = {
  token: "col_camp",
  type: "collection",
  name: "Camp!",
  description: "Outdoor adventure vibes for the nature lover.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=400&h=400&fit=crop",
  season: "new",
  itemCount: 22,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
